import { DEMO_LENGTH } from 'demo/config';

const apocalypse = require('demo/images/apocalypse.png');
const climateChange = require('demo/images/climatechange.png');
const capitalism = require('demo/images/capitalism.png');
const greed = require('demo/images/greed.png');
const death = require('demo/images/death.png');
const religion = require('demo/images/religion.png');
const war = require('demo/images/war.png');
const genocide = require('demo/images/genocide.png');
const pollution = require('demo/images/pollution.png');
const overpopulation = require('demo/images/overpopulation.png');
const annihilation = require('demo/images/annihilation.png');
const socialMedia = require('demo/images/socialmedia.png');
const apathy = require('demo/images/apathy.png');
const noFuture = require('demo/images/nofuture.png');
const die = require('demo/images/die.png');
const theEnd = require('demo/images/theend.png');

const layers = [
  apocalypse,
  'none',
  'none',
  climateChange,
  capitalism,
  greed,
  death,
  'none',
  'none',
  religion,
  war,
  genocide,
  'none',
  'none',
  pollution,
  overpopulation,
  annihilation,
  'none',
  socialMedia,
  apathy,
  'none',
  noFuture,
  noFuture,
  noFuture,
  noFuture,
  noFuture,
  noFuture,
  'none',
  'none',
  die,
  theEnd,
  'none',
];

const omega = require('demo/images/omega.png');

const theend = [
  require('demo/images/theend1.png'),
  require('demo/images/theend2.png'),
  require('demo/images/theend3.png'),
  require('demo/images/theend4.png'),
];

/**
 * Overlay graphics
 */
export default class Overlays {
  /**
   * @param syncDevice JSRocket.SyncDevice
   */
  constructor(syncDevice) {
    this.syncDevice = syncDevice;
    this.textIndex = 0;

    this.overlayContainer = document.getElementById('demo');

    this.overlays = this.createDiv();
    this.overlays.style.mixBlendMode = 'overlay';
    this.overlays.style.backgroundSize = 'cover';

    this.overlays2 = this.createDiv();
    this.overlays2.style.mixBlendMode = 'screen';
    this.overlays2.style.backgroundSize = 'cover';
    this.overlays2.style.opacity = 0.1;

    this.theend = theend.map((image) => {
      const end = this.createDiv();
      end.className = 'the-end';
      end.style.mixBlendMode = 'multiple';
      end.style.backgroundSize = 'cover';
      end.style.backgroundImage = `url(${image})`;
      return end;
    });

    this.omega = this.createDiv();
    this.omega.style.mixBlendMode = 'overlay';
    this.omega.style.backgroundSize = 'cover';
    this.omega.style.backgroundImage = `url(${omega})`;
  }

  createDiv() {
    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.top = '0';
    div.style.left = '0';
    div.style.width = '100%';
    div.style.height = '100%';
    div.style.zIndex = 2;
    div.style.backgroundPosition = 'center center';

    return div;
  }

  /**
   * @param row
   */
  render(row) {
    const endOverlaysAt = DEMO_LENGTH - 5;

    if (row > 64 && row < endOverlaysAt) {
      // show overlay texts
      if (!this.overlayContainer.contains(this.overlays)) {
        this.overlayContainer.appendChild(this.overlays);
        this.overlayContainer.appendChild(this.overlays2);
      }

      if (this.previousRow !== row) {
        this.overlays.style.backgroundImage = `url(${layers[this.textIndex]})`;
        this.overlays2.style.backgroundImage = `url(${layers[this.textIndex]})`;

        this.textIndex++;
        if (this.textIndex >= layers.length) {
          this.textIndex = 0;
        }

        this.previousRow = row;
      }
    } else if (row > endOverlaysAt) {
      // no other overlays here
      if (this.overlayContainer.contains(this.overlays)) {
        this.overlayContainer.removeChild(this.overlays);
        this.overlayContainer.removeChild(this.overlays2);
      }

      // show the end texts
      const theendValue = this.syncDevice.getTrack('theend').getValue(row);
      if (theendValue > 0) {
        const index = theendValue - 1;
        if (!this.overlayContainer.contains(this.theend[index])) {
          this.overlayContainer.appendChild(this.theend[index]);
        }
      } else {
        this.theend.forEach((end) => {
          if (this.overlayContainer.contains(end)) {
            this.overlayContainer.removeChild(end);
          }
        });
      }
    }

    // show omega sign
    // if (row > 128 && row < 224 && !window.document.body.contains(this.omega)) {
    if (row < 64) {
      this.overlayContainer.appendChild(this.omega);
    } else if (this.overlayContainer.contains(this.omega)) {
      this.overlayContainer.removeChild(this.omega);
    }
  }
}
